import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const ProducersList = () => import(/* webpackChunkName: "producers" */ '@/views/Producers/List.vue');
const ProducerCreate = () => import(/* webpackChunkName: "producers" */ '@/views/Producers/Create.vue');
const ProducerShow = () => import(/* webpackChunkName: "producers" */ '@/views/Producers/Show.vue');
const ProducerEdit = () => import(/* webpackChunkName: "producers" */ '@/views/Producers/Edit.vue');

const VisitCreate = () => import(/* webpackChunkName: "producers-visits" */ '@/views/Visits/Create.vue');

const DocumentsList = () => import(/* webpackChunkName: "producers-documents" */ '@/views/Documents/List.vue');
const ContactCreate = () => import(/* webpackChunkName: "producers-contacts" */ '@/views/Contacts/Create.vue');

const ProducerProjectionList = () =>
  import(/* webpackChunkName: "producers-projections" */ '@/views/Projection/List.vue');
const ProducerProjectionCreate = () =>
  import(/* webpackChunkName: "producers-projections" */ '@/views/Projection/Create.vue');

let producersPages = {
  path: '/producers',
  redirect: '/producers',
  component: DashboardLayout,
  name: 'Producers',
  meta: {
    title: 'Productores',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'ProducersList',
      meta: {
        title: 'Listado',
        auth: ['producers.index'],
      },
      component: ProducersList,
    },
    {
      path: 'create',
      name: 'ProducerCreate',
      meta: {
        title: 'Nuevo',
        auth: ['producers.store'],
      },
      component: ProducerCreate,
    },
    {
      path: ':id',
      name: 'ProducerShow',
      meta: {
        title: 'Detalle',
        auth: ['producers.show'],
      },
      component: ProducerShow,
    },
    {
      path: ':id/edit',
      name: 'ProducerEdit',
      meta: {
        title: 'Editar',
        auth: ['producers.update'],
      },
      component: ProducerEdit,
    },
    {
      path: ':id/visits/create',
      name: 'ProducerCreateVisit',
      meta: {
        title: 'Nueva Visita',
        typeToShow: 'Producer',
        resource: 'producers',
        auth: ['visits.store'],
      },
      component: VisitCreate,
    },
    {
      path: ':id/documents',
      name: 'ProducerDocuments',
      meta: {
        title: 'Listado',
        subtitle: 'Documentos del productor',
        type: '',
        entity: 'producers',
        auth: ['producers.show', 'documents.index'],
      },
      component: DocumentsList,
    },
    {
      path: ':id/contacts/create',
      name: 'ProducerCreateContact',
      meta: {
        title: 'Nuevo',
        entity: 'producers',
        auth: ['contacts.store'],
      },
      component: ContactCreate,
    },
    {
      path: ':id/projections',
      name: 'ProducerProjections',
      meta: {
        title: 'Proyección de ventas',
        subtitle: 'Proyección para el productor',
        auth: ['producers.index', 'projections.index'],
      },
      component: ProducerProjectionList,
    },
    {
      path: ':id/projections/create',
      name: 'ProducerProjectionCreate',
      meta: {
        title: 'Crear proyección de ventas',
        subtitle: 'Proyección para el productor',
        auth: ['producers.index', 'projections.store'],
      },
      component: ProducerProjectionCreate,
    },
  ],
};

export default producersPages;
